export const typographyPropsOf = (source)=>({
        variant: source === null || source === void 0 ? void 0 : source.variant,
        skin: source === null || source === void 0 ? void 0 : source.skin,
        weight: source === null || source === void 0 ? void 0 : source.weight,
        ellipsis: source === null || source === void 0 ? void 0 : source.ellipsis
    });
